module.exports = __webpack_public_path__ + "logo.14644648ae06afe41b4b.png";


//////////////////
// WEBPACK FOOTER
// C:/repos/Tulaima/Tulaima-ng/src/img/logo.png
// module id = ../../../../../src/img/logo.png
// module chunks = styles